{
	"optionsCreateOrder": {
		"buy": "Купить",
		"sell": "Продать",
		"orderType": "Тип ордера",
		"price": "Цена",
		"bid": "Bid",
		"ask": "Ask",
		"qty": "Количество",
		"available": "в наличии",
		"orderTerm": "Срок",
		"amount": "Сумма",
		"availableFunds": "Доступные средства",
		"accepted": "Ордер {{ symbol }} был успешно создан",
		"tradingNotAllowed": "Торговля опционами недоступна.",
		"why": "Почему?",
		"whyUnavailable": "Почему опционы недоступны?",
		"possibleReasons": "Одна из возможных причин:",
		"noBrokerAccount": "Вы не открыли брокерский счёт",
		"kycIncomplete": "Вы не завершили процесс подтверждения личности",
		"documentsNotSigned": "Вы не подписали документы",
		"moderationPending": "Вы не прошли модерацию",
		"optionsNotEnabled": "Вы не подключили торговлю опционами",
		"personalDataUpdating": "Персональные данные обновляются, после изменения",
		"contactSupport": "Связаться с поддержкой:",
		"whatsapp": "WhatsApp",
		"email": "E-mail",
		"errors": {
			"notAllowed": "Операции с опционами недоступны"
		},
		"warnings": {
			"closeNotAvailable": "Закрытие позиции Market-ордером сейчас недоступно"
		}
	}
}
